/**
 * Intersection Observer
 * Component for multiple sections animations
 * Optimized for performance and iOS compatibility
 *
 * NEOGEN: Wrapped in a guard so duplicate includes don't crash the page.
 */
(function () {
  // Bail if already loaded
  if (window.__NEOGEN_IO_LOADED__) return;
  window.__NEOGEN_IO_LOADED__ = true;

  // Globals (use window-scoped vars to avoid redeclaration errors)
  window.MOBILE_BREAKPOINT = window.MOBILE_BREAKPOINT || 750;
  window.__NEOGEN_IO_DEFAULT_DELAY__ = window.__NEOGEN_IO_DEFAULT_DELAY__ || 300;
  window.__NEOGEN_IO_DEFAULT_DURATION__ = window.__NEOGEN_IO_DEFAULT_DURATION__ || 900;

  // Helpers
  var DEFAULT_DELAY = window.__NEOGEN_IO_DEFAULT_DELAY__;
  var DEFAULT_DURATION = window.__NEOGEN_IO_DEFAULT_DURATION__;

  function parseIntSafe(value, fallback) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? fallback : parsed;
  }
  function isMobileDevice() {
    return window.innerWidth < window.MOBILE_BREAKPOINT;
  }

  // Main
  document.querySelectorAll('[data-intersection-observer]').forEach(function (intersectElement) {
    var intersectionID = intersectElement.dataset.id;
    var observerElement = document.querySelector('[data-id="' + intersectionID + '"]');
    if (!observerElement) {
      console.warn('Observer element not found for ID:', intersectionID);
      return;
    }

    var intersectOnce = observerElement.dataset.intersectOnce !== 'false';
    var observerOptions = {
      rootMargin: '0px 0px -50% 0px',
      threshold: 0
    };

    // merge options safely
    try {
      var extra = JSON.parse(observerElement.dataset.intersectionObserver || '{}');
      for (var k in extra) observerOptions[k] = extra[k];
    } catch (e) { /* ignore */ }

    var animationBody = observerElement.querySelector('.full-width-banner__animation--body');
    var animationElements = observerElement.querySelectorAll('.full-width-banner__animation');

    var intersectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || intersectionID !== entry.target.dataset.id) return;

        var allowMobileAnimation = observerElement.dataset.animationMobile !== 'false';
        if (isMobileDevice() && !allowMobileAnimation) return;

        if (observerElement.classList.contains('isAnimated') && intersectOnce) return;

        observerElement.classList.remove('inAnimation', 'isAnimated');

        var animationDelay = animationBody ? parseIntSafe(animationBody.dataset.animationDelay, DEFAULT_DELAY) : DEFAULT_DELAY;
        var animationDuration = animationBody ? parseIntSafe(animationBody.dataset.animationDuration, DEFAULT_DURATION) : DEFAULT_DURATION;

        setAnimation(observerElement, animationBody, animationElements, animationDelay, animationDuration);

        var cleanupDelay = (animationElements.length * animationDelay) + (animationDelay + animationDuration);
        setTimeout(function () {
          if (observerElement.classList.contains('isAnimated') && intersectOnce) {
            intersectionObserver.unobserve(observerElement);
          } else if (observerElement.classList.contains('isAnimated') && !intersectOnce) {
            observerElement.classList.remove('isAnimated');
          }
        }, cleanupDelay);
      });
    }, observerOptions);

    intersectionObserver.observe(observerElement);
  });

  function setAnimation(observerElement, animationBody, animationElements, baseDelay, baseDuration) {
    if (!animationElements || !animationElements.length) {
      observerElement.classList.add('isAnimated');
      return;
    }

    observerElement.classList.add('inAnimation');

    var completed = 0;
    var total = animationElements.length;

    animationElements.forEach(function (element, index) {
      var elementDelay = parseIntSafe(element.dataset.animationDelay, baseDelay);
      var elementDuration = parseIntSafe(element.dataset.animationDuration, baseDuration);
      var startDelay = (index + 1) * elementDelay;
      var endDelay = startDelay + elementDuration;

      setTimeout(function () {
        requestAnimationFrame(function () {
          element.classList.add('inAnimation');
          var child = element.querySelector('*');
          if (child) child.style.animationDuration = elementDuration + 'ms';
        });
      }, startDelay);

      setTimeout(function () {
        requestAnimationFrame(function () {
          var child = element.querySelector('*');
          if (child) {
            child.style.animationDuration = '';
            if (!child.style.length) child.removeAttribute('style');
          }
          element.classList.remove('inAnimation');
          element.classList.add('isAnimated');

          completed++;
          if (completed === total) {
            observerElement.classList.remove('inAnimation');
            observerElement.classList.add('isAnimated');
          }
        });
      }, endDelay);
    });
  }
})();
